exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".tblPos {\n  margin-top: 40px; }\n\n.min-width-140 {\n  min-width: 140px !important; }\n\n.width-auto {\n  width: auto !important; }\n\n.badge-current-contents {\n  background-color: #286090 !important;\n  color: #fff !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/branch_management/components/tankers/tankers.scss
// module id = 1014
// module chunks = 1